const fontSizeOptions = {
  'text-h1': 6,
  'text-h2': 4,
  'text-h3': 2,
  'text-base': 0,
};

export default fontSizeOptions;
